<template>
  <!-- 常见问题 -->
  <div class="commonProblem" id="commonProblem">
    <div class="commonProblem-top">
      <img src="../assets/bigTy.png" alt="" />
      <span>对于企业建站，您还应该了解一下</span>
    </div>
    <div class="commonProblem-main">
      <div
        class="commonProblem-mainBox"
        v-for="(item, index) in commonProblemList.lists"
        :key="index"
      >
        <div class="commonProblem-mainBoxLeft">
          <div class="mainBoxLeft-top">
            <img src="../assets/Q.png" alt="" />
            <span>{{ item.name }}</span>
          </div>
          <div class="mainBoxLeft-bottom">
            <div class="bottom-A"><span>A</span></div>
            <p>{{ item.description }}</p>
          </div>
        </div>
        <div class="commonProblem-mainBoxRight">
          <img :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "commonProblem",
  props: {
    commonProblemList: {
      type: Object
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.commonProblem {
  width: 1280px;
  margin: 0 auto;
}
.commonProblem-top {
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin-bottom: 66px;
}
.commonProblem-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.commonProblem-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: 384px;
}
.commonProblem-mainBox {
  height: 190px;
  background: #f6fafb;
  border-radius: 6px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
}
.commonProblem-mainBox:last-child {
  margin-bottom: 100px;
}
.commonProblem-mainBoxLeft {
  padding-top: 34px;
  padding-left: 34px;
}
.mainBoxLeft-top {
  display: flex;
  margin-bottom: 27px;
}
.mainBoxLeft-top img {
  display: block;
  width: 26px;
  height: 26px;
  margin-right: 18px;
}
.mainBoxLeft-top span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.commonProblem-mainBoxRight img {
  display: block;
  width: 494px;
  height: 190px;
}
.mainBoxLeft-bottom {
  display: flex;
}
.bottom-A {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  text-align: center;
  line-height: 26px;
  background-color: #fff;
  margin-right: 18px;
}
.bottom-A span {
  font-size: 18px;
  font-family: DINPro;
  font-weight: 500;
  color: #ef3e3e;
}
.mainBoxLeft-bottom p {
  width: 651px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem.vue